module.exports = __webpack_public_path__ + "img/202114.1064d8ca.png";